import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-1">
      {children}
    </motion.div>;
}
export function AudienceSection() {
  return <section className="w-full py-20 px-4" style={{
    background: 'linear-gradient(180deg, #0a1628 0%, #0c1830 100%)'
  }} data-id="element-2">
      <div className="max-w-4xl mx-auto" data-id="element-3">
        <FadeInUp data-id="element-4">
          <div className="text-center mb-14" data-id="element-5">
            <div className="section-divider mb-6" data-id="element-6">
              <span className="ornament" data-id="element-7">✦</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-8">
              ¿Es Este Programa
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-9">
                Para Ti?
              </span>
            </h2>
          </div>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-10">
          {/* For */}
          <FadeInUp delay={0.1} data-id="element-11">
            <div className="rounded-xl p-8 h-full" style={{
            background: 'rgba(74, 124, 89, 0.08)',
            border: '1px solid rgba(74, 124, 89, 0.35)'
          }} data-id="element-12">
              <div className="flex items-center gap-3 mb-6" data-id="element-13">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
                background: 'rgba(74, 124, 89, 0.2)',
                border: '1px solid var(--color-olive)'
              }} data-id="element-14">
                  <span style={{
                  color: 'var(--color-olive)'
                }} data-id="element-15">
                    ✓
                  </span>
                </div>
                <h3 className="font-heading font-600 text-2xl" style={{
                color: 'var(--color-olive)'
              }} data-id="element-16">
                  Esto Es Para Ti Si...
                </h3>
              </div>
              <div className="space-y-4" data-id="element-17">
                <div className="flex items-start gap-3" data-id="element-18">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'var(--color-olive)'
                }} data-id="element-19">
                    ✦
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-20">
                    Tienes 55+ años y sientes que tu energía ha caído
                    drásticamente.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-21">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'var(--color-olive)'
                }} data-id="element-22">
                    ✦
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-23">
                    Eres hispano en USA y buscas una solución que respete tu fe
                    y tu cultura.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-24">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'var(--color-olive)'
                }} data-id="element-25">
                    ✦
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-26">
                    Sufres de inflamación, dolores articulares o digestión
                    lenta.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-27">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'var(--color-olive)'
                }} data-id="element-28">
                    ✦
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-dim)'
                }} data-id="element-29">
                    Quieres envejecer con dignidad y ser un apoyo para tu
                    familia, no una carga.
                  </p>
                </div>
              </div>
            </div>
          </FadeInUp>

          {/* Not for */}
          <FadeInUp delay={0.2} data-id="element-30">
            <div className="rounded-xl p-8 h-full" style={{
            background: 'rgba(180, 60, 60, 0.05)',
            border: '1px solid rgba(180, 60, 60, 0.2)'
          }} data-id="element-31">
              <div className="flex items-center gap-3 mb-6" data-id="element-32">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
                background: 'rgba(180, 60, 60, 0.15)',
                border: '1px solid rgba(180, 60, 60, 0.3)'
              }} data-id="element-33">
                  <span style={{
                  color: '#e07070'
                }} data-id="element-34">
                    ✗
                  </span>
                </div>
                <h3 className="font-heading font-600 text-2xl" style={{
                color: '#e07070'
              }} data-id="element-35">
                  No Es Para Ti Si...
                </h3>
              </div>
              <div className="space-y-4" data-id="element-36">
                <div className="flex items-start gap-3" data-id="element-37">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'rgba(180, 60, 60, 0.6)'
                }} data-id="element-38">
                    ✗
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-muted)'
                }} data-id="element-39">
                    Buscas una pastilla "milagrosa" para seguir comiendo
                    procesados sin cambiar nada.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-40">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'rgba(180, 60, 60, 0.6)'
                }} data-id="element-41">
                    ✗
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-muted)'
                }} data-id="element-42">
                    No estás dispuesto a ajustar tus horarios de comida por solo
                    21 días.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-43">
                  <span className="flex-shrink-0 mt-1" style={{
                  color: 'rgba(180, 60, 60, 0.6)'
                }} data-id="element-44">
                    ✗
                  </span>
                  <p className="font-body text-base leading-relaxed" style={{
                  color: 'var(--color-cream-muted)'
                }} data-id="element-45">
                    Prefieres soluciones químicas antes que cambios biológicos
                    naturales.
                  </p>
                </div>
              </div>
            </div>
          </FadeInUp>
        </div>
      </div>
    </section>;
}